import React from "react";

export default function MySQL_SUBDATE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SUBDATE</h1>
      <p>This is the MySQL_SUBDATE component generated from the SQL JSON.</p>
    </div>
  );
}
